import React from 'react';

import { VIDEO_ANALYTIC_STATUS_OPTIONS } from '@vlabs/api-bindings/src/constants';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxCustomFilter } from '../components/checkbox-custom-filter/CheckboxCustomFilter';
import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { useFilterCount } from '../hooks';

export const StatusesCheckboxesPopover = ({ onCountChange = undefined }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const selectedStatuses = useWatch({ name: 'statuses' });
  const filterCount = Array.isArray(selectedStatuses) && selectedStatuses.length > 0 ? 1 : 0;
  useFilterCount('status', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="streamStatus"
      triggerValue={t('videoAnalytics:table_header.status')}
    >
      <CheckboxCustomFilter
        control={control}
        isMulti
        name="statuses"
        options={VIDEO_ANALYTIC_STATUS_OPTIONS.raw}
      />
    </CustomFilterPopover>
  );
};
